export default __webpack_public_path__ + "static/media/android-chrome-192x192.d5b35fb4.png";